
export { getSubscriptionStatus, decrementFreeTransforms } from './status';
export { createCheckoutSession } from './checkout';
export type { SubscriptionStatus } from './types';
export { clearCache } from './cache';

// Re-export as a class for backward compatibility
import { getSubscriptionStatus, decrementFreeTransforms } from './status';
import { createCheckoutSession } from './checkout';

export class SubscriptionService {
  static getSubscriptionStatus = getSubscriptionStatus;
  static decrementFreeTransforms = decrementFreeTransforms;
  static createCheckoutSession = createCheckoutSession;
}
